<div
    [ngStyle]="{'left.px': mark.x, 'top.px': mark.y, 'width.px': mark.width, 'height.px': mark.height, 'z-index': zindex}" title="Marker"
    [ngClass]="{'selected': selected}"
    class="marker-bubble {{mark.change}}"
>
  <div><span>{{mark.text}}</span></div>
</div>
